import { createVNode as _createVNode } from "vue";
import { createTableColumn, createTableColumnSlot } from "@/component-create/utils/create-table-column";
import { JOB_RUN_RESULT } from "@/constant/system/code";
import { ElPopover, ElTag } from "element-plus";
import 'element-plus/es/components/popover/style/css'
import 'element-plus/es/components/tag/style/css'

export var jobLogColumn = [createTableColumn('执行器', 'jobExecutor', '160', undefined, {
  showOverflowTooltip: true
}), createTableColumn('执行参数', 'executionParams', undefined, undefined, {
  showOverflowTooltip: true
}), {
  label: '执行时间',
  align: 'center',
  group: [createTableColumn('计划开始', 'scheduledFireTime', '160', 'center'), createTableColumn('实际开始', 'startRunTime', '160', 'center'), createTableColumn('实际结束', 'endRunTime', '160', 'center')]
}, createTableColumnSlot('执行结果', function (row) {
  if (row.executionResult === JOB_RUN_RESULT.FAILED.CODE) {
    return _createVNode(ElTag, {
      "type": "warning"
    }, {
      default: function _default() {
        return [JOB_RUN_RESULT.FAILED.NAME];
      }
    });
  } else if (row.executionResult === JOB_RUN_RESULT.SUCCESS.CODE) {
    return _createVNode(ElTag, {
      "type": "success"
    }, {
      default: function _default() {
        return [JOB_RUN_RESULT.SUCCESS.NAME];
      }
    });
  } else if (row.executionResult === JOB_RUN_RESULT.ERROR.CODE) {
    return _createVNode(ElTag, {
      "type": "danger"
    }, {
      default: function _default() {
        return [JOB_RUN_RESULT.ERROR.NAME];
      }
    });
  } else {
    return h(_createVNode("div", null, null));
  }
}, {
  width: '100',
  align: 'center'
}), createTableColumnSlot('执行日志', function (row) {
  return h(_createVNode(ElPopover, {
    "placement": "top",
    "title": "\u6267\u884C\u65E5\u5FD7",
    "width": "600",
    "trigger": "hover",
    "content": row.executionLog
  }, {
    reference: function reference() {
      return _createVNode("div", {
        "style": {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }
      }, [row.executionLog]);
    }
  }));
}), createTableColumn('创建时间', 'createdAt', '140', 'center', {
  sortable: true
})];